import React from 'react';
import Property from '../assets/images/Icon-dwelling.svg';

export default () => {
  return <img src={Property} alt="" />;
};
